/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type CollectionSortRuleInDirection = typeof CollectionSortRuleInDirection[keyof typeof CollectionSortRuleInDirection];


export const CollectionSortRuleInDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;
